import { render } from "./tellist.vue?vue&type=template&id=699db19c"
import script from "./tellist.vue?vue&type=script&lang=js"
export * from "./tellist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__